import Spinner from './_spinner.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import BetHistoryDetails from './_bet-history-details.js'

export default {
  name: 'BetHistoryDetailsController',
  values: {
    spinner: {
      configSet: Spinner,
      configValues: {
        style: {
          container: {
            flexGrow: 0,
          },
        },
      },
    },
    emptyContent: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '48px',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        },
      },
    },
    loadingLabel: {
      configSet: Text,
      configValues: {
        container: {
          padding: '8px',
          flexGrow: 0,
        },
      },
    },
    betHistoryDetails: {
      configSet: BetHistoryDetails,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
